<template>
    <svg  @click.prevent.stop="togglefav" title="Red Paper Heart" id="RedPaperHeartLogo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="70" viewBox="-70 -32 194.5 90" :fill="colorButton" xml:space="preserve">
    <polygon points="64.5,0 45.6,0 32.2,12.8 18.9,0 0,0 0,18.1 32.2,49 64.5,18.1 " class="favorite" style="cursor:pointer" ></polygon></svg>
</template>

<script>

export default {
  name: 'Favorite',
  props: {
    gFolder: Object

  },
  data () {
    return {

    }
  },
  computed: {
    colorButton () {
      if (this.$store.getters.isFavorite(this.gFolder.id)) {
        return '#ED184D'
      } else {
        return 'grey'
      }
    }
  },
  methods: {
    togglefav () {
      if (this.colorButton === 'grey') {
        const val = {
          id: this.gFolder.id,
          name: this.gFolder.name,
          description: this.gFolder.description
        }
        this.$store.commit('setFavoriteItem', val)
      } else {
        this.$store.commit('deleteFavoriteItem', this.gFolder.id)
      }
    }
  }
}
</script>
